//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// login-invite imports
import { IProps, IState, IContainer } from "./LoginInvite.d";
import { loginInviteFragments } from "./LoginInvite.gql";
import * as s from "./LoginInvite.styles";
// other internals
import { LoginBtn } from "@components/login-btn";
import { H1, P, A } from "@ui";
import { CookieDialog } from "@clockwise/web-commons/src/components/cookie-dialog";
// img
import { defragGif } from "@img/illustrations";
import { coursera, envoy, slack, intercom, twitter, strava } from "@img/customer-logos";
// util
import { PostMessageManager } from "@util/post-message.util";
import { page, PageEvents, track, TrackingEvents } from "@util/analytics.util";
// constants
import { paths } from "@constants/site.constant";
// state
import { IReduxState } from "@reducers/root.reducer";
import { hasSeenLoginPage } from "@state/local-storage";
import { loginUser } from "@mutations";
import { snackBarOpen } from "@actions/snack-bar.actions";
// material-ui
import { LinearProgress } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class LoginInviteCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      loading: false,
      hideCookieErrorDialog: true,
    };
    this.onLoginStart = this.onLoginStart.bind(this);
    this.onLoginSuccess = this.onLoginSuccess.bind(this);
    this.onLoginFailure = this.onLoginFailure.bind(this);
  }

  public componentDidMount() {
    page(PageEvents.SIGNUP);
    hasSeenLoginPage.set(true);
    if (this.props.isChromeExtension) {
      PostMessageManager.openSidebar(true);
    }
  }

  private onLoginStart = () => {
    track(TrackingEvents.AUTH.BEGIN_LOGIN);
    this.setState({ loading: true });
  };

  private onLoginSuccess = () => {
    // nop
  };

  private onLoginFailure = () => {
    track(TrackingEvents.AUTH.LOGIN_FAILED);
    this.setState({ loading: false });
  };

  private onGoogleFailure = (e: any) => {
    if (e.error === "idpiframe_initialization_failed") {
      this.setState({
        hideCookieErrorDialog: false,
      });
    }
  };

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    // detect login success and redirect using current org experiments
    if (nextProps.viewer.user && !this.props.viewer.user) {
      this.setState({ loading: false });
      this.forceUpdate();
    }
  }

  private renderCookieDialog() {
    return (
      <CookieDialog
        isChromeExtension={this.props.isChromeExtension}
        open={!this.state.hideCookieErrorDialog}
      />
    );
  }

  public render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        {this.renderCookieDialog()}
        <div className={classes.container}>
          <div className={classes.paper}>
            <div className={classes.column}>
              <H1 className={classes.header}>
                Join Clockwise and make your calendar work for you.
              </H1>
              <P style={s.subhead}>
                Clockwise is an intelligent calendar assistant that frees up your time so you can
                focus on what matters.
              </P>
              <div className={classes.buttonContainer}>
                <LoginBtn
                  label="Join with Google"
                  googleStandard
                  loginUserMutation={loginUser}
                  style={s.signupBtn.base}
                  labelStyle={{ ...s.signupBtn.label, width: 175 }}
                  redirect={this.props.redirect}
                  onStart={this.onLoginStart}
                  onSuccess={this.onLoginSuccess}
                  onFailure={this.onLoginFailure}
                  onGoogleFailure={this.onGoogleFailure}
                />
              </div>
              <P style={s.agreement}>
                By signing in, you agree to Clockwise's{" "}
                <A style={s.link} target="_blank" href={paths.terms}>
                  {" "}
                  Terms of Service
                </A>{" "}
                and{" "}
                <A style={s.link} target="_blank" href={paths.privacy}>
                  Privacy Policy
                </A>
                .
              </P>
            </div>
            <div className={classes.column}>
              <img className={classes.illustration} src={defragGif} />
            </div>
            {this.state.loading ? (
              <LinearProgress className={classes.loadingBar} variant="indeterminate" />
            ) : (
              ""
            )}
          </div>
          <div className={classes.customerContainer}>
            <P style={s.customerText}>Used and loved by teams at</P>
            <div>
              <div className={classes.customerRow}>
                {/* <div>
                <img className={classes.customerNearlySquarish} src={lyft} alt="Lyft" />
              </div> */}
                <div>
                  <img className={classes.customerPrettyWide} src={slack} alt="Slack" />
                </div>
                <div>
                  <img className={classes.customerPrettyWide} src={intercom} alt="Intercom" />
                </div>
                <div>
                  <img className={classes.customerNearlySquarish} src={twitter} alt="Twitter" />
                </div>
                <div>
                  <img className={classes.customerVeryWide} src={coursera} alt="Coursera" />
                </div>
                <div>
                  <img className={classes.customerPrettyWide} src={envoy} alt="Envoy" />
                </div>
                <div>
                  <img className={classes.customerVeryWide} src={strava} alt="Strava" />
                </div>
              </div>
              {/* other logos */}
              {/* <div>
              <img className={classes.customerPrettyWide} src={curology} alt="Curology" />
            </div>
            <div>
              <img className={classes.customerPrettyWide} src={slack} alt="Slack" />
            </div>
            <div>
              <img className={classes.customerPrettyWide} src={doximity} alt="Doximity" />
            </div>
            <div>
              <img className={classes.customerPrettyWide} src={vimeo} alt="Vimeo Logo" />
            </div>
            <div>
              <img className={classes.customerSlightlyWide} src={turo} alt="Turo" />
            </div>
            <div>
              <img className={classes.customerPrettyWide} src={affinity} alt="Affinity" />
            </div>
            <div>
              <img className={classes.customerVeryWide} src={lattice} alt="Lattice" />
            </div>
            <div>
              <img className={classes.customerVeryWide} src={zymergen} alt="Zymergen" />
            </div>
          </div> */}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
const LoginInviteStyled = withStyles(s.styles)(LoginInviteCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    isChromeExtension: state.webExtension.isWebExtension,
  };
}

const reduxContainer = connect(mapStateToProps, {
  snackBarOpen,
})(LoginInviteStyled);

//////////////////
// RELAY
//////////////////
export const LoginInvite = createFragmentContainer<IContainer>(
  reduxContainer,
  loginInviteFragments,
);
